import { BrandkitPreview } from './BrandkitPreview';
import { Box, Text, Button, Loader, IconButton, StatusIndicator, TextButton } from '@wix/design-system';
import { Add, Refresh } from '@wix/wix-ui-icons-common';
import { BRANDKIT_PICKER_WIDGET } from '../consts';
import { queryBrandkits } from '../api';
import React, { useState, useCallback } from 'react';
import { useDisabledWidget } from '../../../../shared/disabled-widget/useDisabledWidget';
import { EmptyBrandkit } from './EmptyBrandkit';
export const BrandkitPicker = _ref => {
  let {
    data: {
      brandkits,
      widgetLabel,
      emptyStateText,
      primaryButton,
      secondaryButton,
      selectedButton,
      errorWhileQueryBrandkitMessage
    },
    context: {
      send,
      onWidgetAction,
      emitSideEffect,
      httpClient
    },
    config
  } = _ref;
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [showAddButton, setShowAddButton] = useState(true);
  const [updatedBrandkits, setUpdatedBrandkits] = useState(brandkits);
  const [errorMessage, setErrorMessage] = useState(undefined);
  const {
    areControlsDisabled
  } = useDisabledWidget(config);
  const handleWidgetAction = useCallback(actionData => {
    onWidgetAction == null || onWidgetAction(BRANDKIT_PICKER_WIDGET, {
      action: actionData.buttonName,
      value: actionData
    });
    setErrorMessage(undefined);
    emitSideEffect(actionData.sideEffectName, actionData.brandkit);
  }, [onWidgetAction, emitSideEffect]);
  const refreshBrandkits = async () => {
    setIsRefreshing(true);
    try {
      const newBrandkits = await queryBrandkits(httpClient);
      setUpdatedBrandkits(newBrandkits || []);
    } catch (error) {
      setErrorMessage(errorWhileQueryBrandkitMessage);
      console.error(error);
    } finally {
      setIsRefreshing(false);
      setShowAddButton(true);
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: 2,
    paddingTop: "SP1",
    paddingBottom: "SP1",
    width: "100%"
  }, updatedBrandkits.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    size: "medium",
    weight: "thin",
    skin: areControlsDisabled ? 'disabled' : undefined
  }, widgetLabel), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, updatedBrandkits.slice(0, 10).map(brandkit => /*#__PURE__*/React.createElement(BrandkitPreview, {
    isCompleted: areControlsDisabled,
    key: brandkit.id,
    brandkit: brandkit,
    selectedButton: selectedButton,
    send: send,
    onAction: handleWidgetAction
  }))), isRefreshing ? /*#__PURE__*/React.createElement(Box, {
    align: "center",
    padding: "SP10"
  }, /*#__PURE__*/React.createElement(Loader, {
    color: "blue"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    align: "space-between",
    paddingRight: "SP1",
    paddingTop: "SP2"
  }, /*#__PURE__*/React.createElement(TextButton, {
    onClick: () => {
      handleWidgetAction({
        buttonName: secondaryButton.buttonName,
        sideEffectName: secondaryButton.sideEffectName
      });
      send(secondaryButton.respondText);
    },
    size: "tiny",
    disabled: areControlsDisabled
  }, secondaryButton.label), showAddButton ? /*#__PURE__*/React.createElement(Button, {
    disabled: areControlsDisabled,
    onClick: () => {
      emitSideEffect(primaryButton.sideEffectName, undefined);
      setShowAddButton(false);
      setErrorMessage(undefined);
    },
    prefixIcon: /*#__PURE__*/React.createElement(Add, null),
    priority: "secondary",
    size: "tiny"
  }, primaryButton.label) : /*#__PURE__*/React.createElement(IconButton, {
    size: "tiny",
    onClick: refreshBrandkits,
    disabled: isRefreshing || areControlsDisabled,
    skin: "standard",
    priority: "secondary"
  }, /*#__PURE__*/React.createElement(Refresh, null))), errorMessage && /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    width: "100%",
    gap: "6px"
  }, /*#__PURE__*/React.createElement(StatusIndicator, null), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    skin: "error",
    secondary: true
  }, errorMessage)))) : /*#__PURE__*/React.createElement(EmptyBrandkit, {
    emptyStateText: emptyStateText,
    addNewButton: primaryButton,
    addNewButtonOnClick: () => {
      emitSideEffect(primaryButton.sideEffectName, undefined);
      setShowAddButton(false);
      setErrorMessage(undefined);
    },
    skipButtonOnClick: () => {
      handleWidgetAction({
        buttonName: secondaryButton.buttonName,
        sideEffectName: secondaryButton.sideEffectName
      });
      send(secondaryButton.respondText);
    },
    skipButton: secondaryButton,
    areControlsDisabled: areControlsDisabled,
    refreshButton: /*#__PURE__*/React.createElement(IconButton, {
      size: "tiny",
      onClick: refreshBrandkits,
      disabled: isRefreshing || areControlsDisabled,
      skin: "standard",
      priority: "secondary"
    }, /*#__PURE__*/React.createElement(Refresh, null)),
    showAddButton: showAddButton
  }));
};
//# sourceMappingURL=BrandkitPicker.js.map